"use strict";
import _ from 'lodash';

export default class ChampAddController
{
	/*@ngInject*/
	constructor($http, $state, $log, $translate, ValidationService, messageService)
	{
		//console.log("ChampsAddController");
		this.$state = $state;
		this.$http = $http;
		this.$log = $log;
		this.validation = new ValidationService();
		this.messageService = messageService;

		this.data = {};
		this.data.extra = [];
		this.data.classes = [{}];

		this.viewPromise = this.$http.post("/api/backend/champs/newchampdata")
		.then(response =>
		{
			//console.log(response.data);
			//for (var attrname in response.data) { 
			//	this.data[attrname] = response.data[attrname]; 
			//}

			this.data = response.data;
			if (_.isNil(this.data.extra))
				this.data.extra = [];
		});
	}

	Add(form)
	{
		if (!this.validation.checkFormValidity(form)) 
		{
			console.log("ERRORES EN EL FORM");
			this.message = "TODO"; //this.$translate.instant("VALIDATION_ERROR");
			return;
		}
		
		this.$http.post("/api/backend/champs/add", this.CollectChampData(this.data))
		.then(response =>
		{
			this.$state.go("mychamps");
		})
		.catch(err =>
		{
			this.$log.warn(err);
			this.message = err.data;
			this.messageService.Error(err.data);
		});
	}
}



// WEBPACK FOOTER //
// ./client/app/backend/champs/champ_add.controller.js